module.exports = __webpack_public_path__ + "static/media/ps-horizontal.1c3e801f.svg";